<app-modal-container [steps]="steps" [unidadeProdutiva]="unidadeProdutiva" (toggleModalStatus)="modalAberto = $event"  (onUpdate) = "onUpdate()"
  [loading]="loading">
  <modal-etapa-gestao-convite *ngIf="modalAberto" [unidadeProdutiva]="unidadeProdutiva"
    (atualizacaoRealizada)="atualizarEtapa()">
  </modal-etapa-gestao-convite>
</app-modal-container>